// extracted by mini-css-extract-plugin
export default {"container":"Badges_container__MtRsG"};